import React from "react";
import {
  ACTIVITY_FAMILIARITY_OPTIONS,
  COMPETITION_CONTEXT_OPTIONS,
  MODIFICATION_OPTIONS,
  RECOVERY_COST_OPTIONS,
  SOCIAL_FORMAT_OPTIONS,
} from "@/components/daily/companionCalendarV2";

const fieldClass =
  "mt-2 block w-full rounded-xl border border-black/10 bg-white px-3 py-2.5 text-sm forr-text-ink focus:outline-none focus:ring-2 focus:ring-teal-500/30";

const CalendarProgramFields = ({ form, setForm }) => (
  <div className="mt-5 grid gap-5 sm:grid-cols-2">
    <label className="text-sm forr-text-soft">
      Activity familiarity
      <select
        value={form.familiarity}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            familiarity: event.target.value,
          }))
        }
        className={fieldClass}
      >
        {ACTIVITY_FAMILIARITY_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="text-sm forr-text-soft">
      Social format
      <select
        value={form.socialFormat}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            socialFormat: event.target.value,
          }))
        }
        className={fieldClass}
      >
        {SOCIAL_FORMAT_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="text-sm forr-text-soft">
      Competition or evaluation
      <select
        value={form.competitionContext}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            competitionContext: event.target.value,
          }))
        }
        className={fieldClass}
      >
        {COMPETITION_CONTEXT_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="text-sm forr-text-soft">
      Normal recovery cost
      <select
        value={form.recoveryCost}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            recoveryCost: event.target.value,
          }))
        }
        className={fieldClass}
      >
        {RECOVERY_COST_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="text-sm forr-text-soft">
      Can this session be modified?
      <select
        value={form.modifiable}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            modifiable: event.target.value,
          }))
        }
        className={fieldClass}
      >
        {MODIFICATION_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="text-sm forr-text-soft">
      Location
      <input
        value={form.location}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            location: event.target.value,
          }))
        }
        placeholder="Home, gym, field, clinic, outdoors…"
        className={fieldClass}
      />
    </label>

    <label className="text-sm forr-text-soft sm:col-span-2">
      Equipment or environment needed
      <input
        value={form.equipment}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            equipment: event.target.value,
          }))
        }
        placeholder="Weights, bike, pool, court, quiet room, none…"
        className={fieldClass}
      />
    </label>

    <label className="text-sm forr-text-soft sm:col-span-2">
      Program, exercise, or session details
      <textarea
        rows="4"
        value={form.description}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            description: event.target.value,
          }))
        }
        placeholder="Exercises, sets, practice structure, physiotherapy instructions, work demand, counselling focus, modification rules, or anything APOS should account for."
        className={fieldClass}
      />
    </label>
  </div>
);

export default CalendarProgramFields;
